

























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HeadersDataTable } from "@/typings/vuetify/vDataTable";
import { CajaChicaSantiagoOF } from "@/typings/store/plugins/easyFirestore/cajaChicasSantiagoOF";
import { ItemsTablaCajaChicasSantiagoOF } from "@/typings/components/cajaChicasSantiagoOF/tabla";
import "@/helpers/extensions";

@Component
export default class TablaCajaChicasSantiagoOF extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly cajaChicasSantiagoOF!: Array<CajaChicaSantiagoOF>;
  @Prop() readonly usuario!: string;

  options = { page: 1, itemsPerPage: 7, pageCount: 0 };
  headerProps = { sortIcon: "mdi-chevron-down" };
  footerProps = { itemsPerPageOptions: [5, 10, 15, 25], showFirstLastPage: true, showCurrentPage: true, class: "tabla-caja-gerencial__footer" };

  get headers(): HeadersDataTable {
    return [
      { text: "N°", value: "numero" },
      { text: "Fecha", value: "fecha" },
      { text: "Rut Prov", value: "rutProveedor" },
      { text: "Nombre Prov", value: "nombreProveedor" },
      { text: "Acción", value: "accion" },
      { text: "Ingresos", value: "ingreso" },
      { text: "Egresos", value: "egreso" },
      { text: "Documento", value: "documento" },
      { text: "Concepto", value: "concepto" },
      { text: "Comprobante", value: "tieneComprobante", sortable: true, width: "140" },
      { text: "Descripcion", value: "descripcion" },
      { text: "Acciones", value: "opciones", sortable: false, align: "end", width: "96" },
    ];
  }

  get items(): ItemsTablaCajaChicasSantiagoOF {
    return this.cajaChicasSantiagoOF.map((cajaChicaSantiagoOF) => {
      const ingreso = (parseInt(cajaChicaSantiagoOF.ingreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const egreso = (parseInt(cajaChicaSantiagoOF.egreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const archivo = cajaChicaSantiagoOF.archivo;
      const tieneComprobante = !!(archivo && typeof archivo === "object" && Object.keys(archivo).length > 0);
      return {
        numero: cajaChicaSantiagoOF.numero,
        fecha: cajaChicaSantiagoOF.fecha,
        saldoActual: cajaChicaSantiagoOF.saldoActual,
        rutProveedor: cajaChicaSantiagoOF.rutProveedor,
        nombreProveedor: cajaChicaSantiagoOF.nombreProveedor,
        accion: cajaChicaSantiagoOF.accion,
        ingreso,
        egreso,
        documento: cajaChicaSantiagoOF.documento,
        concepto: cajaChicaSantiagoOF.concepto,
        descripcion: cajaChicaSantiagoOF.descripcion,
        tieneComprobante,
        data: cajaChicaSantiagoOF,
      };
    });
  }

  getRowClass(item: { numero: number }): string {
    return `tabla-caja-gerencial__row-num-${item.numero}`;
  }

  onTableClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest("td:last-child") || target.closest("button") || target.closest(".v-menu")) return;
    const tr = target.closest("tbody tr");
    if (!tr) return;
    const match = tr.className.match(/tabla-caja-gerencial__row-num-(\d+)/);
    if (!match) return;
    const numero = parseInt(match[1], 10);
    const item = this.items.find((i) => i.numero === numero);
    if (item && item.data) this.onAbrirInfo(item.data);
  }

  @Emit("abrir-info")
  onAbrirInfo(cajaChicaSantiagoOF: CajaChicaSantiagoOF): CajaChicaSantiagoOF {
    return cajaChicaSantiagoOF;
  }

  @Emit("abrir-editar")
  onAbrirEditar(cajaChicaSantiagoOF: CajaChicaSantiagoOF): CajaChicaSantiagoOF {
    return cajaChicaSantiagoOF;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(cajaChicaSantiagoOF: CajaChicaSantiagoOF): CajaChicaSantiagoOF {
    return cajaChicaSantiagoOF;
  }
}
